module.exports = __webpack_public_path__ + "static/media/006-pompom-blue.2072d8ef.svg";